export default {
      id: "transmission-usage",
      viewBox: "0 0 13 14",
      url: __webpack_public_path__ + "app/svg/sprite.svg#transmission",
      toString: function () {
        return this.url;
      }
    }